// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RnrErrorConverter from "../../../rnr/domain/mapper/RnrErrorConverter.bs.js";
import * as N_RnrClaimEntityMapper from "../entity-mapper/N_RnrClaimEntityMapper.bs.js";
import * as N_RnrConfigEntityMapper from "../entity-mapper/N_RnrConfigEntityMapper.bs.js";
import * as N_RnrReportEntityMapper from "../entity-mapper/N_RnrReportEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as N_RnrVernacularCMSEntityMapper from "../entity-mapper/N_RnrVernacularCMSEntityMapper.bs.js";
import * as N_RnrClaimRewardVernacularCMSEntityMapper from "../entity-mapper/N_RnrClaimRewardVernacularCMSEntityMapper.bs.js";
import * as N_RnrLoginDetailsVernacularCMSEntityMapper from "../entity-mapper/N_RnrLoginDetailsVernacularCMSEntityMapper.bs.js";
import * as N_RnrVideoDetailsVernacularCMSEntityMapper from "../entity-mapper/N_RnrVideoDetailsVernacularCMSEntityMapper.bs.js";

var execute = N_RnrReportEntityMapper.execute;

var RnrReportConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var RnrReportResponseConverter = partial_arg(RnrReportConverterConfig, {
      execute: RnrErrorConverter.execute
    });

var execute$1 = N_RnrClaimEntityMapper.execute;

var RnrClaimConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var RnrClaimResponseConverter = partial_arg$1(RnrClaimConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = N_RnrConfigEntityMapper.execute;

var RnrConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var RnrConfigResponseConverter = partial_arg$2(RnrConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = N_RnrVernacularCMSEntityMapper.execute;

var RnrVernacularCMSConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var RnrVernacularCMSResponseConverter = partial_arg$3(RnrVernacularCMSConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = N_RnrClaimRewardVernacularCMSEntityMapper.execute;

var RnrVernacularClaimRewardCMSConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var RnrVernacularClaimRewardCMSResponseConverter = partial_arg$4(RnrVernacularClaimRewardCMSConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$5 = N_RnrLoginDetailsVernacularCMSEntityMapper.execute;

var RnrVernacularLoginDetailsCMSConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var RnrVernacularLoginDetailsCMSResponseConverter = partial_arg$5(RnrVernacularLoginDetailsCMSConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$6 = N_RnrVideoDetailsVernacularCMSEntityMapper.execute;

var RnrVernacularVideoDetailsCMSConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$Catalyst.ResponseConverter;

var RnrVernacularVideoDetailsCMSResponseConverter = partial_arg$6(RnrVernacularVideoDetailsCMSConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  RnrReportConverterConfig ,
  RnrReportResponseConverter ,
  RnrClaimConverterConfig ,
  RnrClaimResponseConverter ,
  RnrConfig ,
  RnrConfigResponseConverter ,
  RnrVernacularCMSConfig ,
  RnrVernacularCMSResponseConverter ,
  RnrVernacularClaimRewardCMSConfig ,
  RnrVernacularClaimRewardCMSResponseConverter ,
  RnrVernacularLoginDetailsCMSConfig ,
  RnrVernacularLoginDetailsCMSResponseConverter ,
  RnrVernacularVideoDetailsCMSConfig ,
  RnrVernacularVideoDetailsCMSResponseConverter ,
  
}
/* RnrReportResponseConverter Not a pure module */
